import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-count-card',
    imports: [],
    templateUrl: './count-card.component.html',
    styleUrl: './count-card.component.scss'
})
export class CountCardComponent {
  @Input() subTitle: string = '';
  @Input() firstNumber: number = 0;
  @Input() secondNumber: number = 0;
}
